import * as Yup from "yup";
import React from "react";
import FormDefault from "../../components/Forms/FormDefault";
import { Request } from "../../hooks/Request";
import { requestAuth } from "../../components/services/RequestService";
import { toast } from "react-toastify";

const TRANSPORT_MODE_FIELD = "a13ParteModalidadDeTransporte";
const PROVIDERS_DROPDOWN_URL = "/Dropdown/providers/options";

const WEIGHT_ARRIBO_FIELDS = [
  { name: "pesoBruto", label: "Peso Bruto", type: "text" },
  { name: "pesoNeto", label: "Peso Neto", type: "text" },
];

const TERRESTRIAL_ARRIBO_FIELDS = [
  {
    name: "agenteDeCarga",
    label: "Agente de Carga",
    type: "selectGet",
    url: PROVIDERS_DROPDOWN_URL,
    remoteSearch: true,
  },
  { name: "transporteTerrestre", label: "Transporte Terrestre", type: "text" },
  {
    name: "puertoDeEmbarque(Pol)",
    label: "Puerto de Embarque (POL)",
    type: "text",
  },
  {
    name: "puertoDeDestino(Pod)",
    label: "Puerto de Destino (POD)",
    type: "text",
  },
  /* { name: "naviera", label: "Naviera", type: "text" }, */
  /* { name: "cantidad", label: "Cantidad y Tipo de Contenedores", type: "number" }, */
  {
    name: "fechaDevoluciónContenedores",
    label: "Fecha Devolución Contenedores",
    type: "date",
  },
  { name: "n°Bl", label: "N° BL", type: "text" },
  ...WEIGHT_ARRIBO_FIELDS,
  {
    name: "etd",
    label: "Fecha Tentativa Salida de Puerto (ETD)",
    type: "date",
  },
  {
    name: "eta",
    label: "Fecha Tentativa Arribo a Puerto (ETA)",
    type: "date",
    lockEdition: true,
  },
  {
    name: "fechaDeLlegadaAAlmacen",
    label: "Fecha de Llegada a Almacén",
    type: "date",
    lockEdition: true,
  },
  { name: "modalidadDeCarga", label: "Modalidad Despacho", type: "text" },
  // Fuera de la lista terrestre solicitada. Reactivar si se vuelve a pedir.
  // { name: "almacénDestino", label: "Almacén", type: "text" },
];

const MULTIMODAL_ARRIBO_FIELDS = [
  {
    name: "agenteDeCarga",
    label: "Agente de Carga",
    type: "selectGet",
    url: PROVIDERS_DROPDOWN_URL,
    remoteSearch: true,
  },
  {
    name: "naviera",
    label: "Naviera",
    type: "text",
  },
  {
    name: "puertoDeEmbarque(Pol)",
    label: "Puerto de Embarque (POL)",
    type: "text",
  },
  {
    name: "puertoDeDestino(Pod)",
    label: "Puerto de Destino (POD)",
    type: "text",
  },
  {
    name: "cantidad",
    label: "Cantidad y Tipo de Contenedores / BL / Precintos",
    type: "arrivalContainers",
    skipDatasetSubmit: true,
  },
  ...WEIGHT_ARRIBO_FIELDS,
  {
    name: "fechaDevoluciónContenedores",
    label: "Fecha Devolución Contenedores",
    type: "date",
  },
  { name: "transporteTerrestre", label: "Transporte Terrestre", type: "text" },
  {
    name: "etd",
    label: "Fecha Tentativa Salida de Puerto (ETD)",
    type: "date",
  },
  {
    name: "eta",
    label: "Fecha Tentativa Arribo a Puerto (ETA)",
    type: "date",
    lockEdition: true,
  },
  {
    name: "fechaDeLlegadaAAlmacen",
    label: "Fecha de Llegada a Almacén",
    type: "date",
    lockEdition: true,
  },
  /* { name: "modalidadDeCarga", label: "Modalidad Despacho", type: "text" }, */
  // { name: "almacénDestino", label: "Almacén", type: "text" },
];

const MULTIMODAL_CONTAINER_SUMMARY_FIELDS = [
  "siglaDeContenedor",
  "siglaContenedor",
  "precinto",
  "n°Bl",
];

const AERIAL_ARRIBO_FIELDS = [
  {
    name: "agenteDeCarga",
    label: "Agente de Carga",
    type: "selectGet",
    url: PROVIDERS_DROPDOWN_URL,
    remoteSearch: true,
  },
  {
    name: "aeropuertoDeOrigen(Aol)",
    label: "Aeropuerto de Origen(AOL)",
    type: "text",
  },
  {
    name: "aeropuertoDeDestino(Aod)",
    label: "Aeropuerto de Destino(AOD)",
    type: "text",
  },
  ...WEIGHT_ARRIBO_FIELDS,
  { name: "airwaybill", label: "AIRWAYBILL", type: "text" },
  { name: "númeroDeFactura", label: "NÚMERO DE FACTURA", type: "text" },
  {
    name: "etd",
    label: "Fecha Tentativa Salida (ETD)",
    type: "date",
  },
  {
    name: "eta",
    label: "Fecha Tentativa Arribo (ETA)",
    type: "date",
    lockEdition: true,
  },
];

const CALCULATED_FIELDS = ["eta", "fechaDeLlegadaAAlmacen"];

const SHARED_WITH_TRANSPORT_QUOTE_FIELDS = [
  "pesoBruto",
  "pesoNeto",
  "cantidad",
  "almacénDestino",
];

const listFields = Array.from(
  new Set(
    [
      ...TERRESTRIAL_ARRIBO_FIELDS,
      ...MULTIMODAL_ARRIBO_FIELDS,
      ...AERIAL_ARRIBO_FIELDS,
      ...MULTIMODAL_CONTAINER_SUMMARY_FIELDS.map((name) => ({ name })),
    ].map((field) => field.name),
  ),
);

const DATA_VALUE_FIELDS = [
  TRANSPORT_MODE_FIELD,
  "medioTransporte",
  "subastaDeTransporte",
  "puertoOCiudadDeEmbarque",
  "puertoDeDescarga",
  "aeropuertoDeArribo",
  "ciudadDestinoFinal",
  "cantidad",
  "cantidadContenedores",
  "tamanoContenedor",
  "pesoBruto",
  "pesoNeto",
  "modalidadCargaTransporte",
  "modalidadDeCarga",
  "almacénDestino",
  "etd",
  "eta",
  "fechaDeLlegadaAAlmacen",
];

function normalizeMode(value) {
  return `${value || ""}`
    .trim()
    .toUpperCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}

function isAerialMode(value) {
  return normalizeMode(value).includes("AEREO");
}

function isMultimodalMode(value) {
  const mode = normalizeMode(value);
  return mode.includes("MULTIMODAL") || mode.includes("MULTIMODA");
}

function getFormConfig(modeValue) {
  if (isAerialMode(modeValue)) {
    return { fields: AERIAL_ARRIBO_FIELDS, label: "aéreos" };
  }

  if (isMultimodalMode(modeValue)) {
    return { fields: MULTIMODAL_ARRIBO_FIELDS, label: "multimodales" };
  }

  return { fields: TERRESTRIAL_ARRIBO_FIELDS, label: "terrestres" };
}

function parseContainerQuantityAndType(dataValues) {
  const splitQuantity = dataValues?.cantidadContenedores;
  const splitType = dataValues?.tamanoContenedor;

  if (splitQuantity || splitType) {
    return {
      quantity: splitQuantity || "",
      containerType: splitType || "",
      source: "cantidadContenedores",
    };
  }

  const rawQuantity = `${dataValues?.cantidad || ""}`.trim();
  if (!rawQuantity) {
    return { quantity: "", containerType: "", source: "" };
  }

  const match = rawQuantity.match(/^(\d+)\s*(?:x|X)?\s*(.*)$/);
  if (!match) {
    return { quantity: "", containerType: rawQuantity, source: "cantidad" };
  }

  return {
    quantity: match[1] || "",
    containerType: (match[2] || "").trim(),
    source: "cantidad",
  };
}

function getSelectedTransportProvider(dataValues) {
  const selectedTransport = dataValues?.subastaDeTransporteSubDatas?.find(
    (item) =>
      String(item?.description3 ?? item?.Description3 ?? "").toLowerCase() ===
      "true",
  );

  if (!selectedTransport) return "";

  if (selectedTransport.label) return selectedTransport.label;

  try {
    const parsed = JSON.parse(selectedTransport.description2 || "{}");
    return parsed.providerName || "";
  } catch {
    return "";
  }
}

function getApiValue(apiField) {
  const saved = apiField?.dataSets?.[0]?.value;
  if (saved !== undefined && saved !== null && saved !== "") {
    return saved === "false" ? false : saved;
  }

  if (apiField?.initial === "false") return false;

  return apiField?.initial || "";
}

export const FormArriboImportacion = (props) => {
  const { procedure } = props;
  const procedureId = procedure?.id || procedure?.procedureId;
  const parentProcedureId =
    procedure?.parentProcedureId ||
    procedure?.fatherProcedureId ||
    procedure?.fatherProcedure?.id ||
    procedure?.fatherProcedure?.procedureId;
  const shouldLoadParentMode =
    parentProcedureId && String(parentProcedureId) !== String(procedureId);

  const {
    data,
    loading,
    call: reloadFields,
  } = Request({
    urlApi: procedureId
      ? `/Procedure/${procedureId}/datasets?${listFields.map((f) => `fieldnames=${f}`).join("&")}`
      : null,
  });

  const {
    data: dataValues,
    loading: dataValuesLoaded,
    call: reloadDataValues,
  } = Request({
    urlApi: procedureId
      ? `/Procedure/${procedureId}/dataValues?${DATA_VALUE_FIELDS.map((f) => `fieldnames=${f}`).join("&")}`
      : null,
  });

  const { data: parentDataValues, loading: parentDataValuesLoaded } = Request({
    urlApi: shouldLoadParentMode
      ? `/Procedure/${parentProcedureId}/dataValues?fieldnames=${TRANSPORT_MODE_FIELD}`
      : null,
  });

  const parentModeValue =
    parentDataValues?.[TRANSPORT_MODE_FIELD] ||
    procedure?.[TRANSPORT_MODE_FIELD] ||
    "";
  const modeValue =
    parentModeValue ||
    dataValues?.[TRANSPORT_MODE_FIELD] ||
    procedure?.[TRANSPORT_MODE_FIELD] ||
    "";
  const formConfig = getFormConfig(modeValue);
  const activeArriboFields = formConfig.fields;
  const selectedTransportProvider = getSelectedTransportProvider(dataValues);
  const defaultContainerGroup = parseContainerQuantityAndType(dataValues);

  const fallbackValues = {
    "puertoDeEmbarque(Pol)": dataValues?.puertoOCiudadDeEmbarque || "",
    "puertoDeDestino(Pod)":
      dataValues?.puertoDeDescarga || dataValues?.aeropuertoDeArribo || "",
    "aeropuertoDeOrigen(Aol)": dataValues?.puertoOCiudadDeEmbarque || "",
    "aeropuertoDeDestino(Aod)":
      dataValues?.aeropuertoDeArribo || dataValues?.ciudadDestinoFinal || "",
    transporteTerrestre: selectedTransportProvider,
    modalidadDeCarga: dataValues?.modalidadDeCarga || "",
    almacénDestino: dataValues?.["almacénDestino"] || "",
    pesoBruto: dataValues?.pesoBruto || "",
    pesoNeto: dataValues?.pesoNeto || "",
    etd: dataValues?.etd || "",
    eta: dataValues?.eta || "",
    fechaDeLlegadaAAlmacen: dataValues?.fechaDeLlegadaAAlmacen || "",
  };

  function reloadCurrentData() {
    reloadFields();
    reloadDataValues();
  }

  // Merge static definitions with API data (FieldIds + current values)
  function getMergedFields() {
    return activeArriboFields.map((staticField) => {
      const apiField = data?.find((d) => d.name === staticField.name);
      const currentValue = getApiValue(apiField);
      const initialValue =
        currentValue || currentValue === 0 || currentValue === false
          ? currentValue
          : fallbackValues[staticField.name] || "";

      return {
        ...staticField,
        id: apiField?.id || null,
        dataSetId: apiField?.dataSetId || apiField?.dataSets?.[0]?.dataSetId,
        datasetType: apiField?.type || staticField.type,
        summaryFields:
          staticField.name === "cantidad" &&
          staticField.type === "arrivalContainers"
            ? MULTIMODAL_CONTAINER_SUMMARY_FIELDS.map((fieldName) =>
                data?.find((d) => d.name === fieldName),
              ).filter(Boolean)
            : undefined,
        defaultContainerGroup:
          staticField.name === "cantidad" &&
          staticField.type === "arrivalContainers"
            ? defaultContainerGroup
            : undefined,
        initial:
          staticField.name === "transporteTerrestre" &&
          selectedTransportProvider
            ? selectedTransportProvider
            : initialValue,
        validate: apiField?.validate || false,
        url: staticField.url || apiField?.url || null,
      };
    });
  }

  function dataInitialValues(fields) {
    const aux = {};
    fields.forEach((f) => {
      const value = f.initial === "false" ? false : f.initial;
      aux[f.name] = value || value === 0 || value === false ? value : "";
    });
    return aux;
  }

  async function submitDataset(values) {
    await requestAuth("post", "/dataset", values)
      .then(() => {
        reloadCurrentData();
        toast.success("Información de arribo guardada exitosamente");
      })
      .catch(() => {
        toast.error("Error al guardar la información");
      });
  }

  async function onSubmit(values, resetForm, fields) {
    // Campos sin FieldId registrado en el backend: no se pueden guardar (el backend
    // rechaza el lote completo si alguno viene en null), así que se excluyen y se avisa.
    const missingFields = fields.filter(
      (element) => !element.id && !element.skipDatasetSubmit,
    );
    if (missingFields.length > 0) {
      toast.warning(
        `Algunos campos no se guardarán: ${missingFields
          .map((f) => f.label)
          .join(
            ", ",
          )} - falta registrar ese campo en el sistema. Contacta a soporte.`,
      );
    }

    const result = fields
      .filter((element) => element.id && !element.skipDatasetSubmit)
      .map((element) => ({
        Value:
          values[element.name] || values[element.name] === 0
            ? values[element.name]
            : "",
        ProcedureId: procedureId,
        FieldId: element.id,
        name: element.name,
        url: element.url,
        type: element.type,
      }));
    await submitDataset(result);
  }

  if (!procedureId || !loading || !dataValuesLoaded || !parentDataValuesLoaded)
    return null;

  const mergedFields = getMergedFields();
  const modeLabel = modeValue || "No definido";

  return (
    <div>
      <FormDefault
        tittle="Información de Arribo de Importación"
        fields={
          modeValue
            ? mergedFields.map((field, index) => ({
                ...field,
                label: `${index + 1}. ${field.label}`,
                id: procedureId,
                fieldId: field.id,
                placeholder: "Complete el campo",
                type: field.type,
                typeInput: field.type,
                initial:
                  field.initial ||
                  field.initial === 0 ||
                  field.initial === false
                    ? field.initial
                    : null,
                urlApi: field.url
                  ? field.url.includes("/")
                    ? field.url
                    : `/Dropdown/${field.url}/options`
                  : "",
                urlInitial: field.url,
                value: "name",
                labelOption: "name",
                reload: reloadCurrentData,
              }))
            : []
        }
        initialValues={dataInitialValues(mergedFields)}
        validationSchema={Yup.object()}
        bonusContent={
          <div className="mb-4 rounded-lg border border-blue-100 bg-blue-50 px-4 py-3 text-sm text-blue-900">
            <p>
              Modalidad {shouldLoadParentMode ? "del tramite padre" : ""}:{" "}
              <strong>{modeLabel}</strong>.
            </p>
            {!modeValue && (
              <p className="mt-1 text-blue-700">
                <strong>Debe</strong> Definir Modalidad de Transporte.
              </p>
            )}
          </div>
        }
        onSubmit={async (values, resetForm) =>
          await onSubmit(values, resetForm, mergedFields)
        }
        buttonName={modeValue ? "Guardar" : ""}
      />
    </div>
  );
};
